var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBorderNoneSolid = function SvgBorderNoneSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5v4h2V7h2V5zm6 0v2h4V5zm6 0v2h4V5zm6 0v2h2v2h2V5h-4m-8 4v4h2V9zM5 11v4h2v-4zm20 0v4h2v-4zM9 15v2h4v-2zm6 0v2h2v-2zm4 0v2h4v-2zM5 17v4h2v-4zm20 0v4h2v-4zm-10 2v4h2v-4zM5 23v4h4v-2H7v-2zm20 0v2h-2v2h4v-4zm-14 2v2h4v-2zm6 0v2h4v-2z"
  })));
};
export default SvgBorderNoneSolid;